import { Bar, BarChart, CartesianGrid, LabelList, Tooltip, XAxis, YAxis } from "recharts";
import { PAYING_ACCOUNTS } from "./exampleData";
import {
  BORDER,
  CHART_POSITIVE,
  MUTED_FG,
  tooltipStyle,
  xAxisProps,
  yAxisProps,
} from "./chartTheme";
import MetricChartFrame from "./MetricChartFrame";

/**
 * Paying accounts by month — the count of accounts with MRR > 0. The app's
 * positive green, growing from the example's 100 as new logos outpace churn.
 */
const PayingAccountsChart = () => (
  <MetricChartFrame
    caption="Paying accounts grow from 100 to 116 over six months — the simplest measure of customer-base size, and the denominator behind ARPA and customer churn rate."
    chartType="Line"
    breakdown="No breakdown"
    active="6M"
  >
    <BarChart data={PAYING_ACCOUNTS} margin={{ top: 16, right: 8, left: 8, bottom: 0 }}>
      <CartesianGrid strokeDasharray="3 3" stroke={BORDER} vertical={false} />
      <XAxis dataKey="label" {...xAxisProps} />
      <YAxis domain={[0, "dataMax + 8"]} width={36} {...yAxisProps} />
      <Tooltip
        cursor={{ fill: "hsl(var(--muted) / 0.4)" }}
        contentStyle={tooltipStyle}
        formatter={(value: number) => [`${value}`, "Paying accounts"]}
      />
      <Bar dataKey="value" fill={CHART_POSITIVE} radius={[4, 4, 0, 0]} isAnimationActive={false}>
        <LabelList dataKey="value" position="top" fontSize={11} fill={MUTED_FG} />
      </Bar>
    </BarChart>
  </MetricChartFrame>
);

export default PayingAccountsChart;
